<template>
  <div class="row">
    <div class="col-xs-12 mt40">
      <div class="row">
        <div class="col-md-4 col-md-offset-4">
          <button-link
            :href="internoUrl"
            class="btn-block"
            color="default-alt"
          >
            <i class="fa fa-undo-alt"></i> Voltar para IntegradON
          </button-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'button-integradon',
  computed: {
    internoUrl() {
      return process.env.INTERNO_URL
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Buttons/ButtonIntegradon.vue